module.exports = __webpack_public_path__ + "img/task_head_video.5a80684a.png";